import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "z-50 fixed inset-0 h-full flex items-center justify-center"
}
const _hoisted_2 = {
  key: 1,
  class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity bottom-0"
}
const _hoisted_3 = { class: "bg-custom-primaryBlack w-8/12 h-full md:w-3/12 p-4 absolute left-0 pt-12" }

import { computed } from "vue";
import { useDialogsStore } from "@/store/useDialogsStore";
import CrossIcon from "@/components/Icons/CrossIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SideBar',
  props: {
    dialogId: {},
    outSideClosable: { type: Boolean }
  },
  setup(__props: any) {

const dialogsStore = useDialogsStore();

const props = __props;

const isOpen = computed<boolean>(() => {
  return dialogsStore.dialogs[props.dialogId];
});

return (_ctx: any,_cache: any) => {
  return (isOpen.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (props.outSideClosable)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity bottom-0",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(dialogsStore).closeAllModals()))
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(dialogsStore).closeAllModals())),
            class: "cursor-pointer absolute top-2 right-2 text-white hover:text-custom-middleGray"
          }, [
            _createVNode(CrossIcon, { class: "text-white h-6 w-6" })
          ]),
          _renderSlot(_ctx.$slots, "default")
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})